import { IMissingInfo } from 'src/interfaces/user-mobile/missing.interface';
import { instance } from '..';

export const apiMissing = {
  post: (missingInfo: IMissingInfo, festivalId: number, domainName: string) =>
    instance.post(
      '/missingPerson',
      { ...missingInfo, domainName },
      {
        params: { festivalId },
      },
    ),
};
